const API_BASE = process.env.REACT_APP_API_URL || '';

export const trackNewsEvent = (newsGuid, eventType = 'open') => {
  if (!newsGuid) {
    return;
  }

  const payload = JSON.stringify({
    news_guid: newsGuid,
    event_type: eventType,
  });
  const url = `${API_BASE}/api/news/events`;

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
    credentials: 'omit',
  }).catch(() => {});
};
